import { useMemo } from 'react';

import ModalWrapper from 'dashboard/components/ModalWrapper';
import FormUpdateTags, { FormUpdateTagsData } from 'dashboard/forms/FormUpdateTags';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Tag, TagScope } from 'dashboard/models/tag';

interface TagsModalProp {
  tags: Tag[];
  tagScope: TagScope;
  updateTagsModal: boolean;
  isAddTag?: boolean;
  hideUpdateTagsModal: () => void;
  handleUpdateTagsAndClose?: (tags: FormUpdateTagsData) => void;
}

const TagsModal = ({
  tags,
  tagScope,
  updateTagsModal,
  isAddTag = false,
  hideUpdateTagsModal,
  handleUpdateTagsAndClose,
}: TagsModalProp) => {
  const formUpdateTagsInitialValues = useMemo(
    () => ({ tags: tags?.map((t) => t.id) ?? [] }),
    [tags],
  );

  return (
    <ModalWrapper
      isOpen={updateTagsModal}
      handleCloseModal={hideUpdateTagsModal}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
    >
      <ModalContainer data-test='inquiries-show-view__update-tags-modal'>
        <ModalHeader
          data-test='inquiries-show-view__update-tags-modal__header'
          onClose={hideUpdateTagsModal}
        >
          {isAddTag ? 'Add tags' : 'Update tags'}
        </ModalHeader>

        <ModalBody>
          <FormUpdateTags
            initialValues={formUpdateTagsInitialValues}
            onSubmit={handleUpdateTagsAndClose}
            tagScope={tagScope}
            handleCancel={hideUpdateTagsModal}
          />
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default TagsModal;
